import { render, staticRenderFns } from "./Add-Favourite.vue?vue&type=template&id=2cab8931&"
import script from "./Add-Favourite.vue?vue&type=script&lang=js&"
export * from "./Add-Favourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports